"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var Duplicate = function Duplicate(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 30 30"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-961.000000, -518.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(326.000000, 142.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(390.000000, 131.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(245.000000, 245.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6,11.5 C6,12.10753 6.49247,12.6 7.1,12.6 L10.4,12.6 L10.4,15.9 C10.4,16.50753 10.89247,17 11.5,17 C12.10753,17 12.6,16.50753 12.6,15.9 L12.6,12.6 L15.9,12.6 C16.50753,12.6 17,12.10753 17,11.5 C17,10.89247 16.50753,10.4 15.9,10.4 L12.6,10.4 L12.6,7.1 C12.6,6.49247 12.10753,6 11.5,6 C10.89247,6 10.4,6.49247 10.4,7.1 L10.4,10.4 L7.1,10.4 C6.49247,10.4 6,10.89247 6,11.5 Z"
  }), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.8623482,0 L1.2145749,0 C0.544127182,0 0,0.544127182 0,1.2145749 L0,21.8623482 C0,22.5327959 0.544127182,23.0769231 1.2145749,23.0769231 L21.8623482,23.0769231 C22.5327959,23.0769231 23.0769231,22.5327959 23.0769231,21.8623482 L23.0769231,1.2145749 C23.0769231,0.544127182 22.5327959,0 21.8623482,0 Z M20.6477733,20.6477733 L2.4291498,20.6477733 L2.4291498,2.4291498 L20.6477733,2.4291498 L20.6477733,20.6477733 Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.4358974,24.2307692 L27.4358974,27.4358974 L24.2307692,27.4358974 L24.2307692,30 L28.7179487,30 C29.4256435,30 30,29.4256435 30,28.7179487 L30,24.2307692 L27.4358974,24.2307692 Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "16.1538462",
    y: "27.6923077",
    width: "5.76923077",
    height: "2.30769231"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.48717949,27.4358974 L9.48717949,24.2307692 L6.92307692,24.2307692 L6.92307692,28.7179487 C6.92307692,29.4256435 7.49743339,30 8.20512821,30 L12.6923077,30 L12.6923077,27.4358974 L9.48717949,27.4358974 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.7179487,6.92307692 L24.2307692,6.92307692 L24.2307692,9.48717949 L27.4358974,9.48717949 L27.4358974,12.6923077 L30,12.6923077 L30,8.20512821 C30,7.49743339 29.4256435,6.92307692 28.7179487,6.92307692 Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "27.6923077",
    y: "16.1538462",
    width: "2.30769231",
    height: "5.76923077"
  })))))))));
};
/* eslint-enable */
var _default = Duplicate;
exports["default"] = _default;